import _arrayWithHoles from './arrayWithHoles.js';
import _iterableToArrayLimit from './iterableToArrayLimit.js';
import _unsupportedIterableToArray from './unsupportedIterableToArray.js';
import _nonIterableRest from './nonIterableRest.js';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

export { _slicedToArray as default };
